import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const ADD_NOTIFICATION_TO_SEEN = gql`
  mutation addNotificationToSeen {
    addNotificationToSeen
  }
`;
